var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.904,
    height: 17.19,
    viewBox: "0 0 17.904 17.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12229",
    "data-name": "Group 12229",
    transform: "translate(-6775 -17418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44581",
    "data-name": "Path 44581",
    d: "M.01,8.806a2.384,2.384,0,0,1,0-.42c.108-.835,1.03-1.305,1.573-1.8.306-.281.309-.271.234-.691-.152-.843-.681-1.686-.123-2.526.54-.812,1.552-.663,2.387-.725a1.716,1.716,0,0,0,.492-.1A7.179,7.179,0,0,0,5.13,1.206C5.591.167,6.321-.312,7.441.218c.353.167,1.228.9,1.53.884s1.157-.727,1.521-.9a1.541,1.541,0,0,1,2.266.95,7.917,7.917,0,0,0,.58,1.381,1.716,1.716,0,0,0,.492.1c.824.061,1.831-.087,2.372.7a1.936,1.936,0,0,1,.138,1.671,4.558,4.558,0,0,0-.284,1.277c.052.173.855.717,1.042.883a1.65,1.65,0,0,1,0,2.838c-.186.166-.99.713-1.042.883a8.968,8.968,0,0,0,.368,1.648c.226,1.456-.647,1.912-1.931,2-.253.018-.967-.038-1.155.1a7.917,7.917,0,0,0-.58,1.381,1.543,1.543,0,0,1-2.266.95c-.364-.168-1.216-.882-1.521-.9s-1.194.729-1.555.9a1.541,1.541,0,0,1-2.266-.95,7.918,7.918,0,0,0-.58-1.381c-.194-.147-.9-.086-1.155-.1-1.286-.087-2.151-.559-1.93-2A9.06,9.06,0,0,0,1.854,10.9C1.8,10.724,1,10.18.813,10.015a2.324,2.324,0,0,1-.8-1.209M11.636,5.977a.834.834,0,0,0-.376.184L8.028,9.4c-.462-.389-.882-.98-1.345-1.348A.756.756,0,1,0,5.634,9.139a18.571,18.571,0,0,0,1.871,1.872.737.737,0,0,0,1.013,0l3.854-3.877a.753.753,0,0,0-.737-1.159",
    transform: "translate(6775 17418)",
    fill: "#014fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44582",
    "data-name": "Path 44582",
    d: "M122.086,127.8a.753.753,0,0,1,.737,1.159l-3.854,3.877a.737.737,0,0,1-1.013,0,18.57,18.57,0,0,1-1.871-1.872.756.756,0,1,1,1.049-1.087c.463.368.883.959,1.345,1.348l3.232-3.24a.834.834,0,0,1,.376-.184",
    transform: "translate(6664.55 17296.18)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified_icon.185761c4b7458b8d934cc082b63e62f8.svg";
export { ForwardRef as ReactComponent };